import API from "@/services/api";
import { ContractListInfo } from "../types/contractSelectFields";
import axios from "axios";

export enum Endpoints {
  LlistatContractes = "/contracts/list-info/",
}

const getContractList = async () => {
  try {
    const response = await API.get<
      ContractListInfo
    >({
      endpoint: Endpoints.LlistatContractes,
      versions: [2]
    });
    return {
      status: response.promise.status,
      data: response.promise.data
    };
  } catch (error) {
    let statusCode = 500
    if (axios.isAxiosError(error) && error.status) {
      statusCode = error.status
    }

    return {
      status: statusCode,
      data: undefined,
      error: true
    }
  }
};

export default {
  getContractList
};
